<script setup>
import { ref } from 'vue';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ContactMerge from 'dashboard/components-next/Contacts/ContactsSidebar/ContactMerge.vue';

// The old "Combinar" sidebar tab, now opened from the "Más acciones" menu
// of the contact detail header. ContactMerge keeps its own title, form and
// buttons, so the dialog only provides the frame.
defineProps({
  selectedContact: { type: Object, required: true },
});

const emit = defineEmits(['goToContactsList']);

const dialogRef = ref(null);

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :show-cancel-button="false"
    :show-confirm-button="false"
  >
    <ContactMerge
      class="!px-0 !py-0"
      :selected-contact="selectedContact"
      @reset-tab="close"
      @go-to-contacts-list="emit('goToContactsList')"
    />
  </Dialog>
</template>
